var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.dialog, "max-width": "550" },
      on: {
        "click:outside": _vm.close,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _vm.payslip
        ? _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.assign.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Asignar legajo"),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c("p", { staticClass: "mb-1" }, [
                        _vm._v(" Recibo "),
                        _c("b", [_vm._v(_vm._s(_vm.payslip.file_name))]),
                      ]),
                      _c("p", { staticClass: "mb-5" }, [
                        _vm._v(" CUIL leído del PDF: "),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.payslip.extracted_cuil || "no se encontró"
                            )
                          ),
                        ]),
                      ]),
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          items: _vm.legajos,
                          "item-text": _vm.legajoText,
                          "item-value": "id",
                          "return-object": "",
                          label: "Legajo*",
                          name: "legajo",
                          "data-vv-as": "legajo",
                          loading: _vm.loading_legajos,
                        },
                        model: {
                          value: _vm.legajo,
                          callback: function ($$v) {
                            _vm.legajo = $$v
                          },
                          expression: "legajo",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("legajo"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            color: "primary",
                            disabled: _vm.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("preview", _vm.payslip)
                            },
                          },
                        },
                        [_vm._v("Ver recibo")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            text: "",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            text: "",
                            type: "submit",
                            loading: _vm.loading,
                          },
                        },
                        [_vm._v("Asignar")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }